import { getFeature } from 'Cloud/Application/FeaturesEs6';

export const showEditingDocumentFeature: 'a' | 'b' | 'c' = getFeature('show-editing-document-feature');

export const showEditingDocumentFeatureA = showEditingDocumentFeature === 'a';
export const showEditingDocumentFeatureB = showEditingDocumentFeature === 'b';
export const showEditingDocumentFeatureC = showEditingDocumentFeature === 'c';
export const isShowEditingDocumentFeatureEnabled =
    showEditingDocumentFeatureA || showEditingDocumentFeatureB || showEditingDocumentFeatureC;

export const SHOW_EDITING_DOCUMENT_SHORT_FEATURE_TEXT = 'Редактирование документов';
